<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form ref="form" lazy-validation style="height: calc(100% - 100px)">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0">
          <v-list-item-title>
            เลือกพนักงานที่เหลือเพื่อเพิ่มเข้ากลุ่มสิทธิ์
          </v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div style="height: calc(100% - 128px)">
        <div class="px-4 py-4">
          <label class="body-2">
            การเลือกพนักงาน
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            v-model="selectedAddEmployeeType"
            :items="[
              // {
              //   label: 'ทั้งหมด',
              //   value: 'all',
              // },
              {
                label: 'ตามกลุ่มพนักงาน',
                value: 'employeeGroup',
              },
              {
                label: 'ตามหน่วยงาน',
                value: 'organization',
              },
              {
                label: 'พนักงาน',
                value: 'employee',
              },
            ]"
            :rules="[(v) => !!v || 'โปรดระบุประเภทการเพิ่มพนักงาน']"
            item-text="label"
            item-value="value"
            outlined
            dense
            clearable
            @change="handleSelectedAddEmployeeType($event)"
            :loading="loadingSelectedAddEmployeeType"
          >
          </v-autocomplete>
        </div>
        <div class="mx-4" style="height: 100%">
          <div class="text-center" v-if="selectedAddEmployeeType === 'all'">
            <p class="grey--text" v-if="!loadingSelectedAddEmployeeType">
              จำนวนพนักงานทั้งหมด
              <span class="grey--text text--darken-3"
                >{{ totalEmployees }} คน</span
              >
            </p>
            <p v-else>Loading...</p>
          </div>
          <CardAuthorityEmployees
            v-if="selectedAddEmployeeType === 'employee'"
            :accessAuthority="accessAuthority"
            :selectedEmployees="selectedEmployees"
            @onClickBlack="handleClickBack"
            @onCheckEmployee="handleCheckEmployee"
            @onCheckAllEmployee="handleCheckAllEmployee"
            @onClearEmployees="selectedEmployees = []"
            @onClearCheckAllEmployee="checkedAllEmployee = null"
          />
          <CardAuthorityOrganization
            v-if="selectedAddEmployeeType === 'organization'"
            :accessAuthority="accessAuthority"
            :selectedEmployees="selectedEmployees"
            @onClickBlack="handleClickBack"
            @onCheckEmployee="handleCheckEmployee"
            @onCheckAllOrganization="handleCheckAllOrganization"
            @onClearEmployees="selectedEmployees = []"
            @onClearOrganization="selectedOrganization = null"
          />
          <CardAuthorityEmployeeGroup
            v-if="selectedAddEmployeeType === 'employeeGroup'"
            :accessAuthority="accessAuthority"
            :selectedEmployees="selectedEmployees"
            @onClickBlack="handleClickBack"
            @onCheckEmployee="handleCheckEmployee"
            @onCheckAllEmployeeGroup="handleCheckAllEmployeeGroup"
            @onClearEmployees="selectedEmployees = []"
            @onClearEmployeeGroup="selectedEmployeeGroup = null"
          />
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row class="px-3" justify="start" align="center">
          <v-btn
            :disabled="
              // selectedAddEmployeeType !== 'all' &&
              !selectedEmployees.length &&
              selectedEmployeeGroup === null &&
              selectedOrganization === null &&
              checkedAllEmployee === null
            "
            class="primary mr-3"
            depressed
            @click="onSave"
            >เพิ่มพนักงานที่เลือกเข้ากลุ่มสิทธิ์
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import CardAuthorityEmployeeGroup from '@/components/CardAuthorityEmployeeGroup.vue'
import CardAuthorityEmployees from '@/components/CardAuthorityEmployees.vue'
import CardAuthorityOrganization from '@/components/CardAuthorityOrganization.vue'

export default {
  components: {
    CardAuthorityEmployees,
    CardAuthorityEmployeeGroup,
    CardAuthorityOrganization,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    accessAuthority: {
      type: Object,
    },
    accessAuthorityInit: {
      type: Object,
    },
  },
  data() {
    return {
      loadingSelectedAddEmployeeType: false,
      selectedAddEmployeeType: null,
      selectedEmployees: [],
      selectedEmployeeGroup: null,
      selectedOrganization: null,
      checkedAllEmployee: null,
      searchEmployees: '',
      employeeOrganizationFilter: '',
      employeesSort: 'employee_code',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      employeesGroupMember: [],
      totalEmployeesGroupMember: 0,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    lastEmployeesGroupMember() {
      const [lastItem] = this.employeesGroupMember.slice(-1)
      return lastItem || {}
    },
    isEmployeesGroupMemberLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalEmployeesGroupMember / this.pagination.limit)
      )
    },
    employeesGroup() {
      return this.$store.state.employeesGroup.employeesGroup
    },
    totalEmployees() {
      return this.$store.state.employee.totalEmployees
    },
  },
  methods: {
    ...mapActions({
      addAuthorityEmployeeMember: 'accessAuthority/addAuthorityEmployeeMember',
      fetchEmployeesGroupMember: 'employeesGroup/fetchEmployeesGroupMember',

      fetchAccessAuthority: 'accessAuthority/fetchAccessAuthority',

      fetchEmployees: 'employee/fetchEmployees',
    }),
    async handleSelectedAddEmployeeType(value) {
      if (value === 'all') {
        try {
          this.loadingSelectedAddEmployeeType = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            params: {
              dpc: 'access-authority-employee-to-list-employee',
              is_active: true,
              limit: '1',
              offset: '0',
            },
          }

          await this.fetchEmployees(payload)
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.loadingSelectedAddEmployeeType = false
        }
      } else {
        this.selectedEmployees = []
      }
    },
    handleCheckEmployee(value, employee) {
      this.selectedEmployees = value
        ? [...this.selectedEmployees, { ...employee }]
        : this.selectedEmployees.filter(
            (item) => item.employee_uuid !== employee.employee_uuid
          )
    },
    handleCheckAllEmployeeGroup(value, employeeGroup) {
      if (value) {
        this.selectedEmployeeGroup = employeeGroup
        this.selectedEmployees = []
      } else {
        this.selectedEmployeeGroup = null
      }
    },
    handleCheckAllOrganization(value, organization) {
      if (value) {
        this.selectedOrganization = organization
        this.selectedEmployees = []
      } else {
        this.selectedOrganization = null
      }
    },
    handleCheckAllEmployee(value, employee) {
      if (value) {
        this.checkedAllEmployee = employee
        this.selectedEmployees = []
      } else {
        this.checkedAllEmployee = null
      }
    },
    handleClickBack() {
      this.$emit('onClickBack')
      this.selectedAddEmployeeType = null
      this.selectedEmployees = []
      this.$refs.form.resetValidation()
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          let body = {
            include_all: false,
            employee_group_uuids: [],
            organization_uuids: [],
            employee_uuids: [],
          }

          // if (this.selectedAddEmployeeType === 'all') {
          //   body = {
          //     ...body,
          //     include_all: true,
          //   }
          // }
          if (this.selectedAddEmployeeType === 'employeeGroup') {
            body = {
              ...body,
              employee_group_uuids: this.selectedEmployeeGroup
                ? [this.selectedEmployeeGroup]
                : [],
              employee_uuids: this.selectedEmployeeGroup
                ? []
                : this.selectedEmployees.map((item) => item.employee_uuid),
            }
          }
          if (this.selectedAddEmployeeType === 'organization') {
            body = {
              ...body,
              organization_uuids: this.selectedOrganization
                ? [this.selectedOrganization]
                : [],
              employee_uuids: this.selectedOrganization
                ? []
                : this.selectedEmployees.map((item) => item.employee_uuid),
            }
          }
          if (this.selectedAddEmployeeType === 'employee') {
            body = {
              ...body,
              include_all: this.checkedAllEmployee ? true : false,
              employee_uuids: this.checkedAllEmployee
                ? []
                : this.selectedEmployees.map((item) => item.employee_uuid),
            }
          }

          const payload = {
            company_uuid,
            authority_uuid: this.accessAuthority.authority_uuid,
            body,
            params: {
              dpc: 'access-authority-employee-post-delete-to-list-access-authority-employee',
            },
          }

          await this.addAuthorityEmployeeMember(payload)

          const accessAuthority = await this.fetchAccessAuthority({
            company_uuid,
            authority_uuid: this.accessAuthority.authority_uuid,
          })

          this.$store.commit(
            'accessAuthority/EDIT_ACCESS_AUTHORITY',
            accessAuthority
          )

          this.$emit('formActionCompleted', {
            formAction: 'addEmployee',
            formType: 'accessAuthorityAddEmployee',
            accessAuthority,
          })

          this.$emit('onClickBack')

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 4000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.selectedAddEmployeeType = null
          this.selectedEmployeeGroup = null
          this.selectedOrganization = null
          this.checkedAllEmployee = null
          this.selectedEmployees = []
          this.$refs.form.resetValidation()
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    onReset() {
      this.handleClickBack() // TODO: implement reset logic
    },
  },
}
</script>
